export const MATERIAL_FLOW_ACL_ROOT_URL = '/material_flow_acls';
